import { Box, Typography } from "@mui/material";
import React from "react";

function BottomBar() {
  return (
    <Box
      className="layoutMargin width"
      sx={{
        textAlign: "center",
        py: 2,
        zIndex: 5,
        position: "relative",
        color: "#000",
        display: "flex",
        flexDirection: { lg: "row", xs: "column" },
        justifyContent: "space-between",
        background: "#006940",
      }}
    >
      <div style={{paddingLeft:'100px', color:"white"}}>© 2025 Gujco Mall. All Rights Reserved.</div>
      <div>
        <a href="https://www.augmetic.co.uk/" style={{ color: "white", paddingRight: "12px" }} className="color">
          Design & Developed by{" "}
          <span style={{ color: "#1E3226" }}>
            <b style={{color:"white"}}>Augmetic</b>
          </span>
        </a>
      </div>
    </Box>
  );
}

export default BottomBar;
